export default __webpack_public_path__ + "static/media/Hongbao.4602ba09.gif";